import { Component, OnDestroy, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserRecord, Link } from '../../user.model';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'src/app/global/services/message/message.abstract.service';
import { UserService } from '../../service/user.abstract.service';

@Component({
    selector: 'app-remove-family-confirm-dialog',
    templateUrl: './remove-family-confirm-dialog.component.html',
    styleUrls: ['./remove-family-confirm-dialog.component.scss'],
})
export class RemoveFamilyConfirmDialogComponent implements OnDestroy {
    destroy$ = new Subject();

    processingSubmit = false;

    constructor(
        private translateService: TranslateService,
        private dialog: MatDialogRef<RemoveFamilyConfirmDialogComponent>,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data: { userRecord: UserRecord; link: Link },
        private messageService: MessageService,
    ) {}

    get linkLabel() {
        return this.translateService.instant(`pages.userFamily.link.${this.data?.link?.link.toLowerCase()}`);
    }

    closeDialog(): void {
        this.dialog.close();
    }

    submit(): void {
        this.processingSubmit = true;

        this.userService
            .removeFamilyLink(this.data.userRecord.id, this.data.link.userId._id)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response) => {
                    this.messageService.success(this.translateService.instant('pages.userFamily.delete.messages.success'));
                    this.processingSubmit = false;
                    this.dialog.close(true);
                },
                (error) => {
                    this.messageService.error(error?.error?.messages?.[0], this.translateService.instant('pages.userFamily.delete.messages.error'));
                    this.processingSubmit = false;
                },
            );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
